<template>
  <article class="login">
    <section class="login__sect-left">
      <img src='./../../assets/img/logo_fusesecurity.svg' class="login__sect-left__img">
    </section>
    <section class="login__sect-right">
      <div class="login__sect-right__form">
        <h2>Asigne una nueva contraseña</h2>
        <div :class="{'active' : isInError}" class="login_input">
          <label>
                Ingrese su nueva contraseña
          </label>
          <input 
                type="password" 
                required="required"                   
                @input="checkPass" 
                placeholder="Nueva contraseña"
                v-model="password">
        </div>
        <div class="login_input" :class="{'active' : isInErrorPass}">
          <label>Repita su nueva contraseña</label>
          <input
            type="password"
            required="required"
            placeholder="Nueva contraseña"
            v-model="passwordAgain"
            @input="checkPassAgain"
          >
        </div>
        <div v-if="passwordError" class="errorPassword">No se permite la cédula como contraseña, por favor intente una diferente.</div>
        <div class="submit"> 
          <button :class="{'ready': !isEmpty && !isInError && !isInErrorPass}" @click="access" class="submit_button">
            Guardar
          </button>            
        </div>
      </div>
       <!-- <form class="login__sect-right__form">
        
       </form> -->
    </section>
  </article>
</template>
<script>

export default {
  data() {
    return {
      password: "",
      passwordAgain: "",
      isInError: false,
      isInErrorPass: false,
      isEmpty:true,
    };
  },
  methods: {
    access() {
      if (this.password == "") {
        this.isInError = true;
        this.isEmpty = true;
      }
      if (this.passwordAgain == "") {
        this.isInErrorPass = true;
        this.isEmpty = true;
      } 
      else if(this.password != this.passwordAgain){
        this.isInErrorPass = true;
      }

      else {
        this.isInErrorPass = false;
        this.isEmpty = false;
      }



      if (!this.isInError && !this.isInErrorPass) {
        const customActions={
            update: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'PATCH'}
        };


        //Hace la petición de la nueva contraseña y redicerriona a la vista correcta        
        var typeUser = localStorage.getItem('rol');

        if (typeUser == 'admin' || typeUser == 'operator') {
          this.resource= this.$resource('administrators/users/' + JSON.parse(localStorage.getItem('user')).id_card,{},customActions);
        }else{
          this.resource= this.$resource('coordinators/users/' + JSON.parse(localStorage.getItem('user')).id_card,{},customActions);
        }
        
        this.resource.update({"user": this.password})
        .then(function(data){
          this.$router.push({ name: 'Guards' });
          
        }).catch(function(err){
          console.log(err);
          
          this.errorMessage = err.body.errors;
          localStorage.setItem('user', '');
          localStorage.setItem('crypto','');
          localStorage.setItem('device','');
          localStorage.setItem('data','');
          localStorage.setItem('audios','');
          localStorage.setItem('noAuth',true);
          localStorage.setItem('errorMessage','Ha vencido el tiempo de cambio de contraseña por favor comuniquese nuevamente.')
          if(localStorage.getItem('role') ==2){
            this.$router.push("/loginguards");
            
          }else if(localStorage.getItem('role') ==1){
            this.$router.push("/logincoord");

          }
          //alert('Something went wrong')
        });

      }
    },

    checkPass(){
        if (this.password == "") {
            this.isInError = true;
        }else{
            this.isInError = false;
        }
        if(this.passwordAgain){
            this.isEmpty=false;
        }
    },
    checkPassAgain(){
        if (this.passwordAgain == "" || this.passwordAgain!= this.password) {
            this.isInErrorPass = true;
        }else{
            this.isInErrorPass = false;
        }
        if(this.password){
            this.isEmpty=false;
        }

    },
    
  },
  computed: {
    passwordError(){
      if (this.password == this.getUserInfo().id_card) {
        this.isInError = true;
        return true;
      }
      return false;
    }
  },
  
};
</script>

<style scoped>
.errorPassword{
  color: red;
  font-size: 12px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/NewPassword.vue